// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "meta_ads_page".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { metaPagePlatformValues } from '@borradh-workspace/labels';
/** Response atom for the "meta_ads_page" table (1:1 with a DB row, on the wire). */
export const metaAdsPageAtomSchema = z.object({
    id: z.string(),
    metaAdsIntegrationId: z.string(),
    pageId: z.string(),
    pageName: z.string().nullable(),
    pageAccessToken: z.string().nullable(),
    pageUsername: z.string().nullable(),
    pagePictureUrl: z.string().nullable(),
    platform: z.enum(metaPagePlatformValues),
    linkedInstagramAccountId: z.string().nullable(),
    linkedInstagramUsername: z.string().nullable(),
    linkedInstagramName: z.string().nullable(),
    pixelId: z.string().nullable(),
    pixelName: z.string().nullable(),
    defaultLeadFormId: z.string().nullable(),
    defaultLeadFormName: z.string().nullable(),
    defaultAdAccountId: z.string().nullable(),
    defaultAdAccountName: z.string().nullable(),
    defaultAdAccountCurrency: z.string().nullable(),
    isActive: z.boolean(),
    isChatbotActive: z.boolean(),
    isInstagramChatbotActive: z.boolean(),
    lastSyncAt: z.string().datetime().nullable(),
    lastLeadPollAt: z.string().datetime().nullable(),
    leadFormCounts: z.unknown().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=metaAdsPage.js.map